import React, { useState } from "react";
import "../styles/Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="logo">Adrian Weiner</div>

      {/* Hamburger-Icon */}
      <div className={`hamburger ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(!menuOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Mobile Navigation Overlay */}
      <div className={`mobile-menu ${menuOpen ? "active" : ""}`}>
        <button className="close-btn" onClick={() => setMenuOpen(false)}>✕</button>
        <ul className="mobile-nav-links">
          <li><a href="#about" onClick={() => setMenuOpen(false)}>Über mich</a></li>
          <li><a href="#projects" onClick={() => setMenuOpen(false)}>Projekte</a></li>
          <li><a href="#contact" onClick={() => setMenuOpen(false)}>Kontakt</a></li>
        </ul>
      </div>

      {/* Desktop Navigation */}
      <ul className="nav-links">
        <li><a href="#about">Über mich</a></li>
        <li><a href="#projects">Projekte</a></li>
        <li><a href="#contact">Kontakt</a></li>
      </ul>
    </nav>
  );
};

export default Navbar;
